import { autoinject, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ActivableViewModel } from 'framework/aurelia_tools/activable-view-model';
import { ViewModelReference } from 'framework/aurelia_tools/common-types';
import { ToastMessage, ToastService } from 'framework/aurelia_tools/toast-service';
declare const $;

@autoinject
@customElement('bs-toast-item')
export class ToastItem {
  @bindable message: ToastMessage<PartialOptions>;
  element: HTMLDivElement;
  viewModel: ViewModelReference;
  options: ToastOptions;
  toastHandler;

  constructor(private toastService: ToastService<PartialOptions>) { }

  bind() {
    this.viewModel = this.message.viewModel || ActivableViewModel;
    this.options = { ...new ToastOptions(), ...this.message.instruction };
  }

  attached() {
    this.toastHandler = $(this.element).toast({ autohide: this.options.autohide, delay: this.options.delay });
    this.toastHandler.on('hidden.bs.toast', () => this.hidden());
    this.toastHandler.toast('show');
  }

  hidden() {
    this.toastService.dispose(this.message);
  }

  detached() {
    this.toastHandler.toast('dispose');
    this.toastHandler = null;
  }
}

class ToastOptions {
  class: string = null;
  heading: string = null;
  icon: string = null;
  autohide = true;
  delay = 2500;
}

type PartialOptions = Partial<ToastOptions>;
export { PartialOptions as ToastOptions };
